import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  initialAsync,
  downloadAsync,
  addDownloadRecordAsync,
} from "./operations";
import { DownloadState } from "./state";
import { ExecuteSaveHistoryState } from "./types";

// 初期状態のステータス
const initialState: DownloadState = {
  apps: {
    initialize: "Initializing",
    popupTarget: undefined,
    selectProduct: undefined,
  },
  domains: {
    Products: undefined,
  },
};

export const downloadSlice = createSlice({
  name: "download",
  initialState,
  reducers: {
    changePopupTarget: (
      state,
      action: PayloadAction<{
        id: string;
        name: string;
        version: string;
        libVer: string;
        releaseDate: string;
      }>
    ) => {
      const { id, name, version, libVer, releaseDate } = action.payload;
      state.apps.selectProduct = {
        id,
        name,
        version,
        libVer,
        releaseDate,
      };
    },
    clearPopupTarget: (state) => {
      state.apps.popupTarget = initialState.apps.popupTarget;
      state.apps.selectProduct = initialState.apps.selectProduct;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initialAsync.pending, (state) => {
      state.apps = initialState.apps;
      state.domains = initialState.domains;
    });
    builder.addCase(initialAsync.fulfilled, (state, action) => {
      const { payload } = action;
      state.apps = payload.apps;
      state.domains = payload.domains;
    });
    builder.addCase(initialAsync.rejected, (state, action) => {
      // TODO：errorを更新する
      state.apps.initialize = "initializeError";
    });
    builder.addCase(downloadAsync.pending, (state) => {
      // ダウンロードAPI呼び出し中
      state.apps.popupTarget = undefined;
      state.apps.excuteState = "Excuting";
    });
    builder.addCase(downloadAsync.fulfilled, (state, action) => {
      // ダウンロードAPI呼び出し成功時
      state.apps.excuteState = "Excuted";
      const { fileSize, downloadUrl } = action.payload;
      state.apps.popupTarget = {
        id: state.apps.selectProduct ? state.apps.selectProduct.id : "",
        name: state.apps.selectProduct ? state.apps.selectProduct.name : "",
        version: state.apps.selectProduct
          ? state.apps.selectProduct.version
          : "",
        libVer: state.apps.selectProduct?.libVer ?? "",
        releaseDate: state.apps.selectProduct
          ? state.apps.selectProduct.releaseDate
          : "",
        filesize: fileSize,
        downloadurl: downloadUrl,
      };
    });
    builder.addCase(downloadAsync.rejected, (state, action) => {
      // ダウンロードAPI呼び出しエラー時
      state.apps.excuteState = "ExcuteError";
      state.apps.popupTarget = undefined;
    });
    builder.addCase(addDownloadRecordAsync.pending, (state) => {
      state.apps.saveHistoryState = ExecuteSaveHistoryState.Executing;
    });
    builder.addCase(addDownloadRecordAsync.fulfilled, (state) => {
      state.apps.saveHistoryState = ExecuteSaveHistoryState.Executed;
    });
    builder.addCase(addDownloadRecordAsync.rejected, (state) => {
      state.apps.saveHistoryState = ExecuteSaveHistoryState.ExecuteError;
    });
  },
});

export const { clearPopupTarget, changePopupTarget } = downloadSlice.actions;
export default downloadSlice.reducer;
